import * as marietta from '../..';
import { SVGSprite } from '../flash/display';

/**
 * 部屋itemControllerクラス
 */
export default class ItemControllerRoom {
  target: marietta.webcad.item.Room;

  cornerPickerList: marietta.webcad.control.parts.RoomCornerDragger[];

  movePickerList: marietta.webcad.control.parts.RoomMovePicker[];

  startPoint: marietta.core.Point;

  x: number;

  y: number;

  width: number;

  height: number;

  prevPoint: marietta.core.Point;

  currentWall;

  moveAmountX: number;

  moveAmountY: number;

  startCoordinatesWall: marietta.webcad.collection.PointCollection[];

  cornerXPartners: marietta.webcad.control.parts.RoomCornerDragger[];

  cornerYPartners: marietta.webcad.control.parts.RoomCornerDragger[];

  public spt: SVGSprite;

  public emptySpt: SVGSprite;

  /**
   * コンストラクタ
   */
  constructor(_target: marietta.webcad.item.MonicaObject) {
    // ターゲット
    this.target = _target as marietta.webcad.item.Room;

    // 形状の生成
    const viewObj: Element = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    viewObj.id = 'controller';
    this.spt = new SVGSprite(viewObj);

    // ビューの初期化
    this.initMe();

    if (this.target.itemInfo.lock) {
      this.hideToolTips();
    } else {
      this.showToolTips();
    }
  }

  /**
   * コントローラーの初期化
   */
  reInitController() {
    document.getElementById('controller').remove();
    const viewObj: SVGElement = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    viewObj.id = 'controller';
    this.spt = new SVGSprite(viewObj);

    // ビューの初期化
    this.initMe();
 }

  /**
   * 初期化
   */
  initMe() {
    this.cornerPickerList = [];
    this.movePickerList = [];

    // コントローラー追加
    const points: number = this.target.itemInfo.dotList.length;
    let corner: marietta.webcad.control.parts.RoomCornerDragger;
    let wallPicker: marietta.webcad.control.parts.RoomMovePicker;
    for (let i: number = 1; i <= points; i += 1) {
      corner = new marietta.webcad.control.parts.RoomCornerDragger(this.spt, i);
      corner.moveFunc = this.onMoveCornerDragger;
      corner.moveEndFunc = this.onMoveEndCornerDragger;
      this.cornerPickerList.push(corner);

      wallPicker = new marietta.webcad.control.parts.RoomMovePicker(this.spt, i);
      wallPicker.moveFunc = this.onMoveWallDragger;
      wallPicker.moveEndFunc = this.onMoveEndWallDragger;
      this.movePickerList.push(wallPicker);
    }
    if (document.getElementById('controller_snap_guide')) {
      document.getElementById('controller_snap_guide').remove();
    }

    // 作成する階
    const tarLayer: marietta.webcad.layer.FloorShitaeLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(this.target.itemInfo.floor, true) as marietta.webcad.layer.FloorShitaeLayer;
    tarLayer.spt.addChild(this.spt);

    // コントローラーの位置調整
    this.setArrowPositions();

    // ターゲットに合わせてサイズ変更
    this.resizeToTarget();
  }

  /**
   * ターゲットに合わせて各種パーツリサイズ
   */
  resizeToTarget() {
    // 位置合わせ
    this.syncMeToTarget();
  }

  /**
   * ターゲットにシンクロする
   * ※アイテムのドラッグ時に呼び出される
   */
  syncMeToTarget() {
    this.x = this.target.itemInfo.x;
    this.y = this.target.itemInfo.y;

    this.spt.x = this.x;
    this.spt.y = this.y;
    this.spt.update();
  }

  /**
   * ピッカーのサイズ更新
   */
  public updatePickers(): void {
    for (let i: number = 0; i < this.cornerPickerList.length; i += 1) {
      (this.cornerPickerList[i] as marietta.webcad.control.parts.RoomCornerDragger).updateTranslate();
      (this.movePickerList[i] as marietta.webcad.control.parts.RoomMovePicker).updateTranslate();
    }
  }

  /**
   * コントロールピッカーが移動された
   */
  onMoveCornerDragger = (e: MouseEvent, target: marietta.webcad.control.parts.RoomCornerDragger) => {
    // ロックされている場合は、行わない
    if (!this.target.isCapableOfResize()) return;
    // cornerDragの開始時に測定線を非表示にする
    marietta.webcad.WebCADGlobal.itemManager.hideMeasureLine();

    // 開始時のアイテム場所保持
    if (this.startPoint === undefined || this.startPoint === null) {
      this.currentWall = target;
      this.cornerXPartners = [];
      this.cornerYPartners = [];

      if (!this.emptySpt) {
        /*
          本来はtarget.sptのmouseX/mouseYで取得できるが、
          拡縮するとアイテムの位置が変わるため、正しいドラッグ位置が取れなくなる。
          そのためタグを持たないemptySptを別途作って、mouseX/mouseYの値を
          取得している。
        */
        this.emptySpt = new SVGSprite(null, true);
        this.emptySpt.setEmptyParam(this.target.spt);
        this.target.spt.parent.addChild(this.emptySpt);
      }

      this.startPoint = new marietta.core.Point(this.emptySpt.mouseX * this.target.spt.scaleX, this.emptySpt.mouseY * this.target.spt.scaleY);

      // 前後のドットをみて同期して動くドットを選定
      const parnerDotList = [];
      // 前のドット
      if (this.currentWall.index === 1) {
        parnerDotList.push(this.cornerPickerList[this.cornerPickerList.length - 1]);
      } else {
        parnerDotList.push(this.cornerPickerList[this.currentWall.index - 2]);
      }
      // 次のドット
      if (this.currentWall.index === this.cornerPickerList.length) {
        parnerDotList.push(this.cornerPickerList[0]);
      } else {
        parnerDotList.push(this.cornerPickerList[this.currentWall.index]);
      }
      for (let i: number = 0; i < parnerDotList.length; i += 1) {
        if (this.currentWall.x === parnerDotList[i].x) this.cornerXPartners.push(parnerDotList[i]);
        if (this.currentWall.y === parnerDotList[i].y) this.cornerYPartners.push(parnerDotList[i]);
      }
    }

    const newPoint: marietta.core.Point = new marietta.core.Point(this.emptySpt.x + this.emptySpt.mouseX * this.target.spt.scaleX, this.emptySpt.y + this.emptySpt.mouseY * this.target.spt.scaleY);

    // アイテムの角度分、座標変換を行う
    const r: number = -((this.target.spt.rotation % 360) / 180) * Math.PI;
    const xx: number = newPoint.x * Math.cos(r) - newPoint.y * Math.sin(r);
    const yy: number = newPoint.x * Math.sin(r) + newPoint.y * Math.cos(r);
    newPoint.x = xx;
    newPoint.y = yy;

    const snapPosition: marietta.core.Point = ItemControllerRoom.getSnapPosition(newPoint);
    target.move(snapPosition.x - this.emptySpt.x, snapPosition.y - this.emptySpt.y);

    // 隣接ドットの同期
    for (let i = 0; i < this.cornerXPartners.length; i += 1) {
      this.cornerXPartners[i].moveX(snapPosition.x - this.emptySpt.x);
    }
    for (let i = 0; i < this.cornerYPartners.length; i += 1) {
      this.cornerYPartners[i].moveY(snapPosition.y - this.emptySpt.y);
    }

    // 部屋を同期させる
    this.setRoomToMe();
  };

  /**
   * コントロールピッカーのドラッグ終了
   */
  onMoveEndCornerDragger = (e: MouseEvent, target: marietta.webcad.control.parts.RoomCornerDragger) => {
    const p = new Promise((resolve: Function, reject: Function) => {
      this.checkPointOverlap(target, resolve);
    });
    p.then((flag) => {
      this.startPoint = null;
      this.currentWall = null;

      if (this.emptySpt && this.emptySpt.parent) {
        this.emptySpt.parent.removeChild(this.emptySpt);
        this.emptySpt = null;
      }

      // 面積ゼロなら削除
      ItemControllerRoom.areaZeroRemove();

      // ライン測定を更新する
      marietta.webcad.WebCADGlobal.updateMeasureLine(false);
      // cornerDragの最後に測定線を表示する
      marietta.webcad.WebCADGlobal.itemManager.showMeasureLine();
      marietta.webcad.WebCADGlobal.webcad2Dmanager.updateWallList();
      this.target.setParentRoom();
      marietta.webcad.WebCADGlobal.quotationItemList.createData();
    });
  };

  /**
   * 壁点は他の点とオーバーラップしているか
   * 壁を削除する
   * @param target
   */
  checkPointOverlap(target:marietta.webcad.control.parts.RoomCornerDragger, resolve:Function = null) {
    const tarIndex = target.index - 1;
    const nextIndex = tarIndex < this.target.itemInfo.dotList.length - 1 ? tarIndex + 1 : 0;
    const prevIndex = tarIndex > 0 ? tarIndex - 1 : this.target.itemInfo.dotList.length - 1;
    let deleteIndex = null;
    let pointCorrection = null;

    if (marietta.core.Point.distance(this.target.itemInfo.dotList[nextIndex].point, this.target.itemInfo.dotList[tarIndex].point) <= 3) {
      deleteIndex = tarIndex;
    } else if (marietta.core.Point.distance(this.target.itemInfo.dotList[prevIndex].point, this.target.itemInfo.dotList[tarIndex].point) <= 3) {
      deleteIndex = prevIndex;
      pointCorrection = this.target.itemInfo.dotList[prevIndex];
    }
    if (deleteIndex != null) {
      if (pointCorrection != null) {
        this.target.itemInfo.dotList[tarIndex].x = this.target.itemInfo.dotList[prevIndex].x;
        this.target.itemInfo.dotList[tarIndex].y = this.target.itemInfo.dotList[prevIndex].y;
      }
      this.target.itemInfo.dotList.splice(deleteIndex, 1);
      this.target.reCreateImage();
      this.reInitController();
    }
    if (resolve) {
      resolve(true);
    }
  }

  /**
   * コントロールピッカーが移動された
   */
  onMoveWallDragger = (e: MouseEvent, target: marietta.webcad.control.parts.RoomMovePicker) => {
    // ロックされている場合は、行わない
    if (!this.target.isCapableOfResize()) return;

    // wallPoint Dragの開始時に測定線を非表示にする
    marietta.webcad.WebCADGlobal.itemManager.hideMeasureLine();

    // カレント
    this.currentWall = target;

    // 前後のドット
    const parnerDotList = [];
    // 前のドット
    if (this.currentWall.index === this.cornerPickerList.length) {
      parnerDotList.push(this.cornerPickerList[this.cornerPickerList.length - 1]);
    } else {
      parnerDotList.push(this.cornerPickerList[this.currentWall.index - 1]);
    }
    // 次のドット
    if (this.currentWall.index === this.cornerPickerList.length) {
      parnerDotList.push(this.cornerPickerList[0]);
    } else {
      parnerDotList.push(this.cornerPickerList[this.currentWall.index]);
    }

    // ピッカーのXYのいずれかが共通していたら、コーナーのスナップ方式と同等にする。そうでなければ従来の方式にする
    let newPoint: marietta.core.Point;
    let r: number;
    let xx: number;
    let yy: number;
    let snapPosition: marietta.core.Point;

    if (parnerDotList[0].x === parnerDotList[1].x || parnerDotList[0].y === parnerDotList[1].y) {
      // 開始時のアイテム場所保持

      if (this.startPoint === undefined || this.startPoint === null) {
        if (!this.emptySpt) {
          this.emptySpt = new SVGSprite(null, true);
          this.emptySpt.setEmptyParam(this.target.spt);
          this.target.spt.parent.addChild(this.emptySpt);
        }
        this.startPoint = new marietta.core.Point(this.emptySpt.mouseX * this.target.spt.scaleX, this.emptySpt.mouseY * this.target.spt.scaleY);
        // 開始時の座標
        this.startCoordinatesWall = this.target.itemInfo.dotList.concat();
      }
      newPoint = new marietta.core.Point(this.emptySpt.x + this.emptySpt.mouseX * this.target.spt.scaleX, this.emptySpt.y + this.emptySpt.mouseY * this.target.spt.scaleY);
      // アイテムの角度分、座標変換を行う
      r = -((this.target.spt.rotation % 360) / 180) * Math.PI;
      xx = newPoint.x * Math.cos(r) - newPoint.y * Math.sin(r);
      yy = newPoint.x * Math.sin(r) + newPoint.y * Math.cos(r);
      newPoint.x = xx;
      newPoint.y = yy;
      snapPosition = ItemControllerRoom.getSnapPosition(newPoint);
      if (parnerDotList[0].x === parnerDotList[1].x) {
        target.moveX(snapPosition.x - this.emptySpt.x);
        parnerDotList[0].moveX(snapPosition.x - this.emptySpt.x);
        parnerDotList[1].moveX(snapPosition.x - this.emptySpt.x);
      } else {
        target.moveY(snapPosition.y - this.emptySpt.y);
        parnerDotList[0].moveY(snapPosition.y - this.emptySpt.y);
        parnerDotList[1].moveY(snapPosition.y - this.emptySpt.y);
      }
      // 部屋を同期させる
      this.setRoomToMe();

      this.startPoint = null;
      this.currentWall = null;

      if (this.emptySpt && this.emptySpt.parent) {
        this.emptySpt.parent.removeChild(this.emptySpt);
        this.emptySpt = null;
      }
    }
    //----------------------------------------------------

    // 開始時のアイテム場所保持
    if (this.startPoint === undefined || this.startPoint === null) {
      if (!this.emptySpt) {
        /*
          本来はtarget.sptのmouseX/mouseYで取得できるが、
          拡縮するとアイテムの位置が変わるため、正しいドラッグ位置が取れなくなる。
          そのためタグを持たないemptySptを別途作って、mouseX/mouseYの値を
          取得している。
        */
        this.emptySpt = new SVGSprite(null, true);
        this.emptySpt.setEmptyParam(this.target.spt);
        this.target.spt.parent.addChild(this.emptySpt);
      }

      this.startPoint = new marietta.core.Point(this.emptySpt.mouseX * this.target.spt.scaleX, this.emptySpt.mouseY * this.target.spt.scaleY);

      // 開始時の座標
      this.startCoordinatesWall = this.target.itemInfo.dotList.concat();
    }

    if (this.currentWall === null || this.currentWall === undefined) return;

    newPoint = new marietta.core.Point(this.emptySpt.mouseX * this.target.spt.scaleX, this.emptySpt.mouseY * this.target.spt.scaleY);

    // アイテムの角度分、座標変換を行う
    r = -((this.target.spt.rotation % 360) / 180) * Math.PI;
    xx = newPoint.x * Math.cos(r) - newPoint.y * Math.sin(r);
    yy = newPoint.x * Math.sin(r) + newPoint.y * Math.cos(r);
    newPoint.x = xx;
    newPoint.y = yy;

    snapPosition = ItemControllerRoom.getSnapPosition(newPoint);
    // modify k.kubonaka WEBCAD-1020対応
    // この関数の最後でresizeRoomToMe()を呼び、その中でsetArrowPositionsを
    // 呼ぶ事で、moveは実行されるのでこちらではコメントアウトしておく
    // （これが原因でズレが発生しているため）
    // 不備があるようであれば、再調査します
    // this.currentWall.move( snapPosition.x, snapPosition.y );

    // 移動距離
    const snapUnit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
    const tempMoveAmountX: number = snapPosition.x - this.startPoint.x;
    const tempMoveAmountY: number = snapPosition.y - this.startPoint.y;
    const gridX: number = Math.round(tempMoveAmountX / snapUnit) * snapUnit;
    const gridY: number = Math.round(tempMoveAmountY / snapUnit) * snapUnit;

    let amari: number = tempMoveAmountX % snapUnit;
    const doSnapX: Boolean = Boolean(amari < snapUnit);
    amari = tempMoveAmountY % snapUnit;
    const doSnapY: Boolean = Boolean(amari < snapUnit);

    this.moveAmountX = doSnapX ? gridX : tempMoveAmountX;
    this.moveAmountY = doSnapY ? gridY : tempMoveAmountY;

    // 方向を特定する
    // if (target.rotation % 90 === 0 || target.rotation === 0) {
    //   let vertical: Boolean = false;
    //   if (target.rotation === 90 || target.rotation === -90) {
    //     vertical = true;
    //   }

    //   // modify k.kubonaka WEBCAD-1020対応
    //   // この関数の最後でresizeRoomToMe()を呼び、その中でsetArrowPositionsを
    //   // 呼ぶ事で、moveは実行されるのでこちらではコメントアウトしておく
    //   // （これが原因でズレが発生しているため）
    //   // 不備があるようであれば、再調査します

    //   // this.currentWall.move( vertical?this.startPoint.x:this.startPoint.x + this.moveAmountX, vertical?this.startPoint.y + this.moveAmountY:this.startPoint.y);
    // } else {
    //   // modify k.kubonaka WEBCAD-1020対応
    //   // この関数の最後でresizeRoomToMe()を呼び、その中でsetArrowPositionsを
    //   // 呼ぶ事で、moveは実行されるのでこちらではコメントアウトしておく
    //   // （これが原因でズレが発生しているため）
    //   // 不備があるようであれば、再調査します

    //   // this.currentWall.move( this.startPoint.x + this.moveAmountX, this.startPoint.y + this.moveAmountY );
    // }

    // 部屋を同期させる
    this.resizeRoomToMe();
  };

  /**
   * コントロールピッカーのドラッグ終了
   */
  onMoveEndWallDragger = () => {
    this.startPoint = null;
    this.startCoordinatesWall = null;
    this.currentWall = null;
    this.prevPoint = null;

    if (this.emptySpt && this.emptySpt.parent) {
      this.emptySpt.parent.removeChild(this.emptySpt);
      this.emptySpt = null;
    }

    // 面積ゼロなら削除
    ItemControllerRoom.areaZeroRemove();

    // ライン測定を更新する
    marietta.webcad.WebCADGlobal.updateMeasureLine(false);
    // wallPoint Dragの最後に測定線を表示する
    marietta.webcad.WebCADGlobal.itemManager.showMeasureLine();
    marietta.webcad.WebCADGlobal.webcad2Dmanager.updateWallList();
    this.target.setParentRoom();
    marietta.webcad.WebCADGlobal.quotationItemList.createData();
  };

  /**
   * コーナーピッカー全て同じ座標（面積ゼロなら部屋を削除）
   */
  protected static areaZeroRemove() {
    marietta.webcad.WebCADGlobal.cadAPIManager.MakeRoomWall();
    const target = marietta.webcad.WebCADGlobal.itemManager.currentItem;
    if (marietta.webcad.util.WebCADUtil.isAreaZero(target.itemInfo.dotList)) {
      target.deleteMe();
    }
  }

  /**
   * 部屋の大きさをあわせる
   * */
  resizeRoomToMe(force: boolean = false) {
    if (force) this.prevPoint = null;

    // 前回と同じ位置なら、行わない
    if (this.prevPoint != null && this.prevPoint.x === this.emptySpt.mouseX && this.prevPoint.y === this.emptySpt.mouseY) return;
    this.prevPoint = new marietta.core.Point(this.emptySpt.mouseX, this.emptySpt.mouseY);

    // ドラッグ開始時の頂点をコピー
    const newCoordinates: marietta.webcad.collection.PointCollection[] = [];
    for (let i: number = 0; i < this.movePickerList.length; i += 1) {
      newCoordinates.push(new marietta.webcad.collection.PointCollection(this.startCoordinatesWall[i].x, this.startCoordinatesWall[i].y, this.startCoordinatesWall[i].wall_type, this.startCoordinatesWall[i].guid));
      if (this.startCoordinatesWall[i].inner_end_item_info) {
        newCoordinates[i].inner_end_item_info = this.startCoordinatesWall[i].inner_end_item_info;
      }
    }
    // ドラッグしている辺に影響する頂点の座標を変更する
    const { index } = this.currentWall as marietta.webcad.control.parts.RoomMovePicker;
    const p1: number = index - 1;
    const p2: number = index === this.movePickerList.length ? 0 : index;

    // 方向を特定する
    let vertical: Boolean = false;
    if ((this.currentWall as marietta.webcad.control.parts.RoomMovePicker).rotation === 90 || (this.currentWall as marietta.webcad.control.parts.RoomMovePicker).rotation === -90) {
      vertical = true;
    }
    // 方向を特定する
    if ((this.currentWall as marietta.webcad.control.parts.RoomMovePicker).rotation % 90 === 0 || (this.currentWall as marietta.webcad.control.parts.RoomMovePicker).rotation === 0) {
      if ((this.currentWall as marietta.webcad.control.parts.RoomMovePicker).rotation === 90 || (this.currentWall as marietta.webcad.control.parts.RoomMovePicker).rotation === -90) {
        vertical = true;
      }
      // 頂点を変更する
      newCoordinates[p1].x += vertical ? 0 : this.moveAmountX;
      newCoordinates[p1].y += vertical ? this.moveAmountY : 0;
      newCoordinates[p2].x += vertical ? 0 : this.moveAmountX;
      newCoordinates[p2].y += vertical ? this.moveAmountY : 0;
    } else {
      // 頂点を変更する
      newCoordinates[p1].x += this.moveAmountX;
      newCoordinates[p1].y += this.moveAmountY;
      newCoordinates[p2].x += this.moveAmountX;
      newCoordinates[p2].y += this.moveAmountY;
    }
    this.target.itemInfo.dotList = newCoordinates;
    this.target.reCreateImage();

    // 関連するシンボルの位置移動
    this.setArrowPositions();
  }

  /**
   * 矢印をグリッドにスナップさせる
   * */
  protected static getSnapPosition(point: marietta.core.Point) {
    const snapUnit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
    const gridPlace: marietta.core.Point = new marietta.core.Point(0, 0);
    gridPlace.x = Math.round(point.x / snapUnit) * snapUnit;
    gridPlace.y = Math.round(point.y / snapUnit) * snapUnit;
    return gridPlace;
  }

  /**
   * 部屋の大きさを変える
   * */
  setRoomToMe(force: Boolean = false) {
    if (force) this.prevPoint = null;

    // 前回と同じ位置なら、行わない
    if (this.prevPoint != null && this.prevPoint.x === this.emptySpt.mouseX && this.prevPoint.y === this.emptySpt.mouseY) return;
    this.prevPoint = new marietta.core.Point(this.emptySpt.mouseX, this.emptySpt.mouseY);

    // 部屋アイテムに更新
    this.target.itemInfo.dotList = this.currentCoordinates;
    this.target.reCreateImage();
    // 関連するシンボルの位置移動
    this.setArrowPositions();
  }

  /**
   * 現在の座標を取得
   * */
  get currentCoordinates(): marietta.webcad.collection.PointCollection[] {
    const points: number = this.cornerPickerList.length;
    const myCoordinates: marietta.webcad.collection.PointCollection[] = [];
    let tarSymbol: marietta.webcad.control.parts.RoomCornerDragger;
    let wallType: number;

    for (let i: number = 0; i < points; i += 1) {
      tarSymbol = this.cornerPickerList[i] as marietta.webcad.control.parts.RoomCornerDragger;
      wallType = this.target.itemInfo.dotList[i].wall_type;
      myCoordinates.push(new marietta.webcad.collection.PointCollection(tarSymbol.x, tarSymbol.y, wallType, this.target.itemInfo.dotList[i].guid));
    }
    return myCoordinates;
  }

  /**
   * 矢印位置を合わせる
   * */
  setArrowPositions() {
    // 頂点作成
    let points: number = this.target.itemInfo.dotList.length;
    let cornerPicker: marietta.webcad.control.parts.RoomCornerDragger;
    let i: number;
    for (i = 0; i < this.cornerPickerList.length; i += 1) {
      cornerPicker = this.cornerPickerList[i];
      cornerPicker.move(this.target.itemInfo.dotList[i].x, this.target.itemInfo.dotList[i].y);
    }
    // 頂点作成
    let ceterPoint: marietta.core.Point;
    let movePicker: marietta.webcad.control.parts.RoomMovePicker;
    let point1: marietta.core.Point;
    let point2: marietta.core.Point;
    let angle: number;
    let pRadian: number;
    for (i = 0; i < points; i += 1) {
      movePicker = this.movePickerList[i];
      point1 = new marietta.core.Point(this.target.itemInfo.dotList[i].x, this.target.itemInfo.dotList[i].y);
      point2 = i === points - 1 ? new marietta.core.Point(this.target.itemInfo.dotList[0].x, this.target.itemInfo.dotList[0].y) : new marietta.core.Point(this.target.itemInfo.dotList[i + 1].x, this.target.itemInfo.dotList[i + 1].y);
      ceterPoint = marietta.core.Point.interpolate(point1, point2, 0.5);
      if (movePicker.x !== ceterPoint.x || movePicker.y !== ceterPoint.y) {
        movePicker.move(ceterPoint.x, ceterPoint.y);
        // 角度
        pRadian = Math.atan2(point1.x - point2.x, point1.y - point2.y);
        angle = pRadian / (Math.PI / 180);
        movePicker.rotate(-angle);
      }
    }
    this.resizeToTarget();

    // お掃除
    points = null;
    cornerPicker = null;
    ceterPoint = null;
    movePicker = null;
    point1 = null;
    point2 = null;
    angle = null;
    pRadian = null;
  }

  /**
   * Translateのアップデート
   */
  updateTransforms() {
    this.spt.x = this.x;
    this.spt.y = this.y;
    this.spt.update();
  }

  /**
   * ツールチップを非表示
   */
  hideToolTips() {
    for (let i: number = 0; i < this.cornerPickerList.length; i += 1) {
      (this.cornerPickerList[i] as marietta.webcad.control.parts.RoomCornerDragger).disableDragger();
    }

    for (let i: number = 0; i < this.movePickerList.length; i += 1) {
      (this.movePickerList[i] as marietta.webcad.control.parts.RoomMovePicker).disableDragger();
    }
  }

  /**
   * ツールチップを表示する
   */
  showToolTips() {
    for (let i: number = 0; i < this.cornerPickerList.length; i += 1) {
      (this.cornerPickerList[i] as marietta.webcad.control.parts.RoomCornerDragger).enableDragger();
    }
    for (let i: number = 0; i < this.movePickerList.length; i += 1) {
      (this.movePickerList[i] as marietta.webcad.control.parts.RoomMovePicker).enableDragger();
    }
  }
}
